import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListChallengeClipsRequest } from './list-challenge-clips-request';
import type { IListChallengeClipsResponse } from './list-challenge-clips-response';
import { listChallengeClipsResponseSchema } from './list-challenge-clips-response';

export async function listChallengeClipsApi({
  challengeId,
}: IListChallengeClipsRequest): Promise<IValidatedResponse<IListChallengeClipsResponse>> {
  return getRequest<IListChallengeClipsResponse>({
    path: `/sys/challenges/${challengeId}/clips`,
    schema: listChallengeClipsResponseSchema,
  });
}
